import moment from 'moment-timezone'
import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'

export const dmAdminUtils = ({
  getEntryId: function (url) {
    var arr = url.split('/')
    if (arr !== undefined) {
      var entryIdIndex = parseInt(arr.indexOf('entryId'))
      return arr[entryIdIndex + 1]
    }
    return ''
  },
  getFlavourId: function (url) {
    var arr = url.split('/')
    if (arr !== undefined) {
      var flavorIdIndex = parseInt(arr.indexOf('flavorId'))
      return arr[flavorIdIndex + 1]
    }
    return ''
  },
  isValidUrl: function (url) {
    try {
      // eslint-disable-next-line
      new URL(url)
      return true
    } catch (err) {
      return false
    }
  },
  checkForVideoFileExtesion: function (url) {
    var exts = ['.mp4']
    return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
      url
    )
  },
  checkForAudioFileExtesion: function (url) {
    var exts = ['.mp3']
    return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
      url
    )
  },
  getEntryAndFlavourIds: function (url) {
    if (url !== undefined && url !== 'undefined' && url !== null && url !== 'null' && url !== '') {
      var arr = url.split('/')
      if (arr !== undefined) {
        var entryIdIndex = parseInt(arr.indexOf('entryId'))
        var flavorIdIndex = parseInt(arr.indexOf('flavorId'))
        return {
          EntryId: arr[entryIdIndex + 1],
          FlavorId: arr[flavorIdIndex + 1]
        }
      } else {
        return {
          EntryId: '',
          FlavorId: ''
        }
      }
    } else {
      return {
        EntryId: '',
        FlavorId: ''
      }
    }
  },
  getCurrentEst: function (addDay = 0, addHour = 0, addMinute = 0) {
    var m = moment().add(addDay, 'days').add(addHour, 'hours').add(addMinute, 'minutes')
    return m.tz('America/New_York').format('MM/DD/YYYY h:mm:ss A')
  },
  covertUtcToEst: function (date) {
    var m = moment(date)
    return m.tz('America/New_York').format('MM/DD/YYYY h:mm:ss A')
  },
  formatDateAndTime: function (date) {
    var m = moment(date)
    return m.format('MM/DD/YYYY h:mm:ss A')
  },
  truncateString: function (stringToTruncate, maxChar) {
    return stringToTruncate.substring(0, maxChar)
  },
  covertUtcToEstWithoutTime: function (date) {
    var m = moment(date)
    return m.tz('America/New_York').format('MM/DD/YYYY')
  },
  getMonthInWordFromDate: function (date) {
    var m = moment(date.replace('0000', '2001'))
    return m.format('MMM-DD-YYYY')
  },
  getHumanReadableDate: function (date) {
    var m = moment(date.replace('0000', '2001'))
    return m.format('MM-DD-YYYY')
  },
  getStartOfNextEstDay: function () {
    var nextDay = moment.utc().add(1, 'days').startOf('day')
    return nextDay.tz('America/New_York').format('MM/DD/YYYY h:mm:ss A z')
  },
  replaceAllOccurances: function (str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace)
  },
  isFutureDateTime: function (date1) {
    var currEst = moment(this.getCurrentEst(), 'MM/DD/YYYY h:mm:ss A')
    var parsedDate = moment(date1, 'MM/DD/YYYY h:mm:ss A')
    return parsedDate.isAfter(currEst)
  },
  formatDateAndTimeWithOutTimeZone: function (date) {
    var m = moment(date.replace('0000', '2001')).utc(false)
    return m.format('MM/DD/YYYY h:mm:ss A')
  },
  getHumanReadableEST: function (date) {
    var m = moment(date)
    return m.tz('America/New_York').format('DD MMM YYYY h:mm:ss A')
  },
  updateUrls: function (content) {
    if (isEmpty(content)) {
      return content
    }
    var newContent = content
    const regEx = /(http(s?):)([/|.|\w|\s|-])*\.(?:png|jpg|jpeg|gif|png|svg)/gi
    const results = newContent.match(regEx)
    map(results, (url) => {
      var newUrl = url + '?t=' + new Date().getTime()
      newContent = newContent.replace(new RegExp(url, 'g'), newUrl)
    })
    return newContent
  },
  removeTFromUrls: function (content) {
    if (isEmpty(content)) {
      return content
    }
    var newContent = content
    const regEx = /(http(s?):)([/|.|\w|\s|-])*\.(?:png|jpg|jpeg|gif|png|svg)(\?t=\d+)*/gi
    const results = newContent.match(regEx)
    map(results, (url) => {
      const index = url.indexOf('?')
      if (index > -1) {
        const remove = url.substr(index)
        const orgUrl = url.replace(remove, '')
        newContent = newContent.replace(url, orgUrl)
      }
    })
    return newContent
  },
  convertSecondsToMinFormat: function (duration, returnPostStr = false) {
    var mins = ~~((duration % 3600) / 60)
    var secs = duration % 60
    var valueToReturn = ''
    valueToReturn += '' + mins + ':' + (secs < 10 ? '0' : '')
    valueToReturn += '' + secs
    return !returnPostStr ? valueToReturn : (valueToReturn + ' min')
  }
})



// WEBPACK FOOTER //
// ./src/utils/dmAdminUtils.js